import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { AppView, AppMainView } from '../../../../components/AppView'
import AppHeader from '../../../../components/AppView/Header'
import { ComplianceStore, ComplianceStep } from './ComplianceStore'
import { LocationAndMonthSelector } from './LocationAndMonthSelector'
import { FixInventoryLogs } from './FixInventoryLogs'
import { GenerateComplianceReport } from './GenerateComplianceReport'
import { Analyze } from './Analyze'
import { ComplianceNavigator } from './ComplianceNavigator'
import { HelpLinkMenu } from '../../../../components/GrDropdown/HelpLinkMenu/HelpLinkMenu'
import Helmet from 'react-helmet'
import { CompaniesModels } from '@getgreenline/companies'
import { HelpLinks } from '../../../../constants/ExternalLinks'

interface IComplianceBodyProps {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

export const ComplianceBody = React.memo(
  observer(({ currentCompanyStore, complianceStore }: IComplianceBodyProps) => {
    switch (complianceStore.currentStep) {
      case ComplianceStep.LocationMonth:
        return <LocationAndMonthSelector complianceStore={complianceStore} />
      case ComplianceStep.Fix:
        return (
          <FixInventoryLogs
            currentCompanyStore={currentCompanyStore}
            complianceStore={complianceStore}
          />
        )
      case ComplianceStep.Preview:
        return <Analyze complianceStore={complianceStore} />
      case ComplianceStep.Generate:
        return (
          <GenerateComplianceReport
            currentCompanyStore={currentCompanyStore}
            complianceStore={complianceStore}
          />
        )
      default:
        return <div />
    }
  }),
)

interface IProps {
  currentCompanyStore?: CurrentCompanyStore
}

@inject('currentCompanyStore')
@observer
export class Compliance extends React.Component<IProps, {}> {
  currentProvince = this.props.currentCompanyStore!.company?.province as CompaniesModels.Province

  complianceStore = new ComplianceStore({
    province: this.currentProvince,
  })

  componentDidMount() {
    this.complianceStore.observeCurrentStepInUrl()
  }

  componentWillUnmount() {
    this.complianceStore.unObserveCurrentStepInUrl()
  }

  render() {
    const currentCompanyStore = this.props.currentCompanyStore!
    const company = currentCompanyStore!.company!

    return (
      <AppView column>
        <Helmet>
          <title>Reports | Compliance</title>
          <meta name='page-loaded' content='true' />
        </Helmet>
        <AppHeader title={`Compliance (${company.province || 'No province'})`}>
          <HelpLinkMenu
            helpLinkMenus={{
              title: 'Compliance',
              href: HelpLinks.REPORTS_COMPLIANCE,
            }}
          />
        </AppHeader>
        <AppMainView>
          <ComplianceNavigator complianceStore={this.complianceStore} />
          <hr />
          <br />
          <ComplianceBody
            currentCompanyStore={currentCompanyStore}
            complianceStore={this.complianceStore}
          />
          <div style={{ height: 100 }} />
        </AppMainView>
      </AppView>
    )
  }
}
